import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=2dff46d5&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dff46d5')) {
      api.createRecord('2dff46d5', component.options)
    } else {
      api.reload('2dff46d5', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=2dff46d5&", function () {
      api.rerender('2dff46d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/venveo-modal/components/modal.vue"
export default component.exports